export default {
  title: 'Invoice',
  customerFilterPlaceholder: 'Semua customer',
  searchTextPlaceholder: 'Cari Nomor Invoice',
  invoiceNo: 'No Invoice',
  customerName: 'Nama Customer',
  transactionPeriod: 'Periode Pesanan',
  totalCost: 'Total Tagihan',
  createdBy: 'Dibuat oleh',
  status: 'Status',
  type: 'Tipe',
  orders: 'Pesanan',
  selected: 'Terpilih : ',
  createInvoice: 'Buat Invoice',
  editInvoice: 'Perbarui Invoice',
  shipmentNo: 'No Pesanan',
  transporterName: 'Rekanan 3PL',
  vehicle: 'Kendaraan',
  price: 'Harga',
  qty: 'Quantity',
  unitPrice: 'Harga Per Unit',
  documentCompletion: 'Kelengkapan Dokumen',
  oracleResubmitButtonTitle: 'gagal submit ke oracle, tekan untuk coba lagi',
  invoiceStatusDateInputDialogTitle: 'Masukkan Tanggal Invoice',
  receiveStatusLabel: 'Di Terima',
  paidStatusLabel: 'Di Bayarkan',
  shipmentGroupNo: 'Nomor Kiriman'
}
